import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e377fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-full items-center text-white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold mr-10" }, "TQUK", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/forms" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/forms",
      class: "mr-8 opacity-75 flex h-full items-center"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Forms ")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/contacts",
      class: "mr-8 opacity-75 flex h-full items-center"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Contacts ")
      ]),
      _: 1
    })
  ]))
}